export function dateToInputString(date) {
    const year = date.getFullYear();
    const day = date.getDate();
    const month = date.getMonth() + 1;

    return `${year}-${month < 10 ? "0"+month : month}-${day < 10 ? "0"+day : day}`
}